import React from 'react'
import { StyleSheet } from '@react-pdf/renderer'
import { View } from './Primitives';
import CheckInAndDeparture from "./BodyParts/CheckinAndDeparture";
import HeaderDetail from "./BodyParts/HeaderDetail";
import Route from './BodyParts/Routes'
import Bid from './BodyParts/Bid';
import BidHistoryDetail from './BodyParts/BidHistoryDetail';
import CharterDetail from './BodyParts/CharterDetail';
const styles = StyleSheet.create({


    author: {
        fontSize: 12,
        textAlign: 'center',
        marginBottom: 40,
    },
    subtitle: {
        fontSize: 18,


    },
    title: {
        fontSize: 20,
        paddingBottom:20,

    },
    text: {
        margin: 12,
        fontSize: 14,
        textAlign: 'justify',
        fontFamily: 'Times-Roman'
    },

    borderBox: {
        border: '1pt solid #000',
    },
    flexContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-between',
        marginLeft:30,
        marginRight:30,
    },
    flexBox:{
        display:'flex',
        flex:1,
        border: '1pt solid #000',
        padding:15
    },
    bodyContainer: {
        marginLeft:30,
        marginRight:30,
    },
content:{backgroundColor:'red'}

});


const Body = ({ charter, bidHistory, auth, newPdfType, includeImages=true}) => {
    return    <React.Fragment>
        {bidHistory?<BidHistoryDetail charter={charter}/>:<View style={styles.flexContainer}>
            <HeaderDetail auth={auth} charter={charter}></HeaderDetail>
        <CheckInAndDeparture/>
        </View>}
        {bidHistory?<CharterDetail charter={charter}/>:null}
        {charter.routes.map((x, i) => <Route auth={auth} charter={charter} key={i} route={x} bidHistory={bidHistory} newPdfType={newPdfType}/>)}
        {bidHistory && charter.bids.filter(x => x.status !== 'Unavailable' &&x.status !== 'Void').map((y, i) => <Bid includeImages={includeImages} charter={charter} key={i} index={i} bid={y} />)}
                
    </React.Fragment>
}


export default Body;